import { render, staticRenderFns } from "./PqrsReportingPage.vue?vue&type=template&id=50f8748e"
import script from "./PqrsReportingPage.vue?vue&type=script&lang=js"
export * from "./PqrsReportingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports